var map = {
	"./2024-05-15_1.jpg": 9691,
	"./2024-05-15_2.jpg": 9068,
	"./2024-05-15_3.jpg": 4329,
	"./2024-05-15_4.jpg": 7866,
	"./2024-05-15_5.jpg": 5383,
	"./2024-05-15_6.jpg": 8104,
	"./2024-05-15_7.jpg": 2069,
	"./2024-05-15_8.jpg": 5606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1837;